// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var ContractOrdersController = function ($scope, $routeParams, $location, $http, Contract, Order) {
    $scope.orders = Order.query({ contractId: $routeParams.contractId });
};
ContractOrdersController.$inject = ['$scope', '$routeParams', '$location', '$http', 'Contract', 'Order'];
